export default __webpack_public_path__ + "static/media/Group.fd571335.png";